var React = require('react');

function Flourish (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M81.91,0.11l0.6,0.6L79.52,3.7H45l-3.86,3.53L37.28,3.7H2.77L0,0.93l0.6-0.6l2.52,2.52h34.49l3.54,3.23\n\tl3.53-3.23h34.49L81.91,0.11z","key":0}),React.createElement("path",{"className":"st1","d":"M52.05,0.56h-0.23l-0.16,0.17c-3.47,3.46-6.93,6.93-10.4,10.4c-3.47-3.47-6.93-6.93-10.4-10.4L30.7,0.56h-0.23","key":1})]);
}

Flourish.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 82.51 11.84","style":{"enableBackground":"new 0 0 82.51 11.84"},"xmlSpace":"preserve"};

module.exports = Flourish;

Flourish.default = Flourish;
